var ImageTypeNameEnum;
(function (ImageTypeNameEnum) {
    ImageTypeNameEnum["mainProductPicture"] = "Main Product Picture";
    ImageTypeNameEnum["contextProductPicture"] = "Context Product Picture";
    ImageTypeNameEnum["functionalProductPicture"] = "Functional Product Picture";
    ImageTypeNameEnum["inspirationalProductPicture"] = "Inspirational Product Picture";
    /**
     * Images that shows measurements.
     *
     * For instance when applied to a Malm bureau, it will show the entire bureau measurements, as well as the drawers measurements.
     */
    ImageTypeNameEnum["measurementIllustration"] = "Measurement Illustration";
})(ImageTypeNameEnum || (ImageTypeNameEnum = {}));
export default ImageTypeNameEnum;
//# sourceMappingURL=ImageTypeNameEnum.js.map